export const STATUS_STYLE: Record<string, string> = {
  active: 'border-green-500/50 text-green-400',
  pending: 'border-yellow-500/50 text-yellow-400',
  suspended: 'border-red-500/50 text-red-400',
};
